namespace $.$$ {

	$.$shm_hitalama_compat_fqn_install( $ as any )

	// http://localhost:9080/shm/hitalama/app/-/test.html
	// http://localhost:9080/shm/hitalama/app/-/test.html#!domain_page=true
	// http://localhost:9080/shm/hitalama/app/-/test.html#!section=hidden_reg

	const master_arg = $shm_hitalama_app_arg( 'master' )
	if( master_arg ) $.$giper_baza_yard.masters_default = [ new URL( '/', master_arg ).toString() ]
	
	export class $shm_hitalama_app extends $.$shm_hitalama_app {

		@ $mol_memo.field
		get $() {
			return super.$.$mol_ambient({
				$mol_button_copy: $shm_button_copy as any,
			})
		}

		title(): string {
			return 'Hitalama'
		}

		version_data_default() {
			return {
				version: '-',
				date: '-',
			}
		}

		version_data() {
			return this.$.$mol_error_fence(
				()=> this.$.$mol_fetch.json( '/shm/hitalama/app/_version.json', { cache: 'no-store' } ) as { version?: string, date?: string },
				()=> this.version_data_default(),
				promise => $mol_fail_hidden( promise ),
			)
		}

		version_data_version() {
			return String( this.version_data().version || this.version_data_default().version )
		}

		version_data_date() {
			return String( this.version_data().date || this.version_data_default().date )
		}

		internal_auth_spread( spread: string ) {
			return spread === 'enter' || spread === 'register' || spread === 'enterkey' || spread === 'hidden_reg'
		}

		Spread_current() {
			const spread = this.spread()
			if( this.internal_auth_spread( spread ) ) return this.Spread_default()
			return this.Spread( spread )
		}

		login(): string {
			// console.log('this.profiles()', this.profiles().keys())
			return this.$.$shm_hitalama_profile.current()?.Login()?.val() ?? ''
		}

		entergate_pending_login_key() {
			return '$' + 'hitalama_profile_gate.pending_login'
		}

		entergate_pending_login( next?: string | null ) {
			return this.$.$mol_state_local.value< string >( this.entergate_pending_login_key(), next ) ?? ''
		}

		entergate_auth_exists() {
			return Boolean( this.$.$mol_state_local.value< string >( '$giper_baza_auth' ) )
		}

		@ $mol_action
		entergate_pending_auto() {
			const login = this.entergate_pending_login().trim()
			if( !login ) {
				if( this.entergate_auth_exists() && !this.login() ) {
					this.$.$shm_hitalama_profile.home().land().sync()
				}
				return null
			}

			const auth = this.$.$giper_baza_auth.current()
			const profile = this.$.$giper_baza_glob
				.land_grab( [[ null, this.$.$giper_baza_rank_make( 'post', 'just' ) ]] )
				.Data( this.$.$shm_hitalama_profile )
			profile?.Login( null )!.val( login )
			profile?.Pass_key( null )!.val( auth.toString() )
			profile?.version( $shm_hitalama_profile_migration.latest_version() )
			if( this.$.$shm_hitalama_settings.selfhosted_tauri_enabled() ) profile?.selfhosted_defaults_ensure()

			if( profile ) {
				const home = $shm_hitalama_profile.home()
				home.Hitalama_profile( null )!.remote( profile )
				this.entergate_pending_login( null )
				this.$.$mol_state_arg.value( 'section', null )
				this.$.$shm_hitalama_app.selfhosted_tauri_logout( false )
			}

			return null
		}

		static selfhosted_tauri_logout_key() {
			return `${ this }.selfhosted_tauri_logout`
		}

		static selfhosted_tauri_logout( next?: boolean ) {
			return this.$.$mol_state_local.value< boolean >( this.selfhosted_tauri_logout_key(), next )
		}

		@ $mol_action
		selfhosted_tauri_admin_auto() {
			if( !this.$.$shm_hitalama_settings.selfhosted_tauri_enabled() ) return null

			const login = 'admin'
			const password = 'admin'
			const domain = this.$.$shm_hitalama_domain.instance()
			const profiles = domain.profiles_ensure()

			const existed = profiles.key( login )?.remote()
			if( existed ) {
				existed.selfhosted_defaults_ensure()
				if( $shm_hitalama_app.selfhosted_tauri_logout() ) return null
				if( this.login() ) return null
				existed.enter( password )
				return null
			}

			const profile = profiles.key( login, 'auto' )?.remote( this.$.$shm_hitalama_profile.current() )
			if( !profile ) return null

			profile.Login(null)!.val( login )
			profile.version( $shm_hitalama_profile_migration.latest_version() )
			profile.password( password )
			profile.selfhosted_defaults_ensure()

			if( $shm_hitalama_app.selfhosted_tauri_logout() ) return null
			if( this.login() ) return null

			const home = $shm_hitalama_profile.home()
			home.Hitalama_profile(null)!.remote( profile )
			return null
		}

		Map(): $.$shm_hitalama_map_book {
			this.guest_app_query_drop()
			return this.Maps().Book( this.map_id() )
		}

		guest_app_query_drop() {
			const location = this.$.$mol_dom_context.location
			const uri = new URL( location.href )
			if( uri.searchParams.get( 'guest_app' ) !== '1' ) return null

			uri.searchParams.delete( 'guest_app' )
			this.$.$mol_dom_context.history.replaceState( null, '', `${ uri.pathname }${ uri.search }${ uri.hash }` )
			return null
		}

		document() {
			return this.$.$mol_dom_context.document
		}

		@ $mol_action
		add_map( access_level: keyof ReturnType<typeof $shm_hitalama_map.access_level_to_ranks> ) {
			return this.Maps().add_map( access_level )
		}

		@ $mol_mem
		command_palette_keydown_handler() {
			return $mol_wire_async( ( event: KeyboardEvent ) => {
				if( event.code === 'KeyP' && ( event.ctrlKey || event.metaKey ) && event.shiftKey ) {
					event.preventDefault()
					this.command_palette_opened( true )
					return
				}

				if( event.code === 'KeyY' && ( event.ctrlKey || event.metaKey ) && event.shiftKey ) {
					event.preventDefault()
					const opened = this.$.$mol_state_arg.value( 'domain_page' ) === 'true'
					this.$.$mol_state_arg.value( 'domain_page', opened ? null : 'true' )
					return
				}

				if( event.key === 'Escape' && this.command_palette_opened() ) {
					event.preventDefault()
					this.command_palette_opened( false )
					return
				}

				const fullscreen_disable_key = this.$.$shm_hitalama_settings.fullscreen_disable_key()
				if( fullscreen_disable_key && event.key === fullscreen_disable_key && this.$.$mol_state_arg.value( 'fullscreen_widget' ) ) {
					event.preventDefault()
					this.$.$mol_state_arg.value( 'fullscreen_widget', null )
				}
			} )
		}

		@ $mol_mem
		Fullscreen(): $.$shm_hitalama_app_fullscreen {
			$mol_wire_solid()
			return super.Fullscreen()
		}

		sub(): readonly ( $mol_view )[] {
			if( $shm_hitalama_app.tg_params() ) { //hack tg app
				return [
					this.Map(),
					this.Fullscreen(),
					... this.domain_page_view(),
				]
			}

			const is_extension = this.$.$mol_state_arg.value( 'extension' )!
			if( is_extension ) return [
				this.Ext(),
				... this.domain_page_view(),
			]

			const No_auth_page = (this.no_auth_pages() as any)[ this.spread() ]
			if( No_auth_page ) return [No_auth_page]

			if( !this.login() ) return [
				... super.sub(),
				... this.domain_page_view(),
			]

			return [
				... super.sub(),
				... this.domain_page_view(),
			]
		}

		chat_view(): readonly ( any )[] {
			if( !this.chat_opened() ) return []
			return [ this.spread() === 'projects' ? this.Project_chat() : this.Map_chat() ]
		}

		chat_opened( next?: boolean ) {
			return this.$.$mol_state_local.value( `${ this }.chat_opened`, next ) ?? false
		}

		maps_list_visible( next?: boolean ) {
			return this.$.$mol_state_local.value( `${ this }.maps_list_visible`, next ) ?? true
		}

		projects_list_visible( next?: boolean ) {
			return this.$.$mol_state_local.value( `${ this }.projects_list_visible`, next ) ?? true
		}

		chat_width( next?: number ) {
			return this.$.$mol_state_local.value( `${ this }.chat_width`, next ) ?? super.chat_width()
		}

		process_monitor_view(): readonly ( any )[] {
			return this.process_monitor_opened() ? [this.Process_monitor()] : []
		}

		side_views(): readonly ( any )[] {
			return [
				... this.process_monitor_view(),
				... this.chat_view(),
			]
		}

		domain_page_view(): readonly ( any )[] {
			return this.$.$mol_state_arg.value( 'domain_page' ) === 'true' ? [this.Domain_page()] : []
		}

		side_views_auto() {
			return this.side_views().map( view => view.auto?.() ?? null )
		}

		@ $mol_mem
		mcp_client() {
			return this.$.$shm_hitalama_mcp_client.make({
				app: ()=> this,
			})
		}

		mcp_client_auto() {
			return this.mcp_client().auto()
		}

		@ $mol_mem
		book_pages() {
			const spread = this.spread()
			if( spread === 'projects' ) return [
				this.Book_menu(),
				this.Projects(),
				... this.side_views(),
			]

			let login = this.login()
			if( !login ) {
				if( spread === 'map' ) return [
					this.Map(),
					... this.side_views()
				]

				if( this.entergate_auth_exists() ) {
					this.$.$shm_hitalama_profile.home().land().sync()
					login = this.login()
				}

				if( !login ) return [ this.Internal_register() ]
			}
			
			const spread_current = this.internal_auth_spread( spread ) ? '' : spread

			switch( spread_current ) {
				case 'map':
					return [
						this.Map(),
						... this.side_views()
					]
				case '':
				case 'lists':
					return super.book_pages()
			}

			const spread_view = spread_current === '' ? this.Spread_default() : this.Spread( spread_current )
			return [
				this.Book_menu(),
				spread_view,
				... this.side_views()
			]
		}

		@ $mol_mem
		profiles() {
			return $shm_hitalama_domain.instance().profiles_ensure()
		}

		@ $mol_mem
		map_id() {
			return this.$.$mol_state_arg.value( 'map' )!
		}
		@ $mol_mem
		map() {
			let id = this.map_id()
			// if( $shm_hitalama_app.tg_params() ) { //hack tg app
			// 	id = $shm_hitalama_app.tg_params()?.map!
			// }
			return $giper_baza_glob.Pawn( new $giper_baza_link( id ), $shm_hitalama_map )
		}

		static _tg_params: any
		@ $mol_mem
		static tg_params() {
			if( this._tg_params ) return this._tg_params

			const hash = document.location.hash
			if( !hash.startsWith( '#&%2333' ) ) return null

			// const params = new URLSearchParams( hash )
			// const map = params.get('#33;section')?.slice( 12 )

			// const tgWebAppData = new URLSearchParams( params.get( 'tgWebAppData' )! )
			// const user: { 
			// 	id: number,
			// 	first_name: string,
			// 	last_name: string,
			// 	username: string,
			// 	photo_url: string,
			// } = JSON.parse( tgWebAppData.get( 'user' )! )

			const tg = $mol_import.script('https://telegram.org/js/telegram-web-app.js').Telegram.WebApp
			this._tg_params = tg.initDataUnsafe
			
			const decoded = tg_hash_decode( hash )
			const cleaned_hash = decoded.split('&tgWebAppData')[0]
			document.location.hash = cleaned_hash

			return this._tg_params
		}

	}

	function tg_hash_decode( str: string ) {
		let decoded
		do {
			decoded = str
			str = decodeURIComponent( str.replace( /\+/g, ' ' ) )
			str = str.replace( /&#(\d+);/g, ( m, code ) => String.fromCharCode( code ) )
			str = str.replace( /&#x([0-9a-f]+);/gi, ( m, hex ) => String.fromCharCode( parseInt( hex, 16 ) ) )
		} while( decoded !== str && str.includes( '%' ) )
		return str
	}

	function $shm_hitalama_app_arg( key: string ) {
		const hash = $.$mol_dom_context.location.hash.replace( /^#!/, '' ).replace( /^#/, '' )
		for( const chunk of hash.split( '/' ) ) {
			const vals = chunk.split( '=' ).map( decodeURIComponent )
			if( vals.shift() === key ) return vals.join( '=' ) || ''
		}
		return null
	}

}
